/**
 * Header — editorial topbar (paper aesthetic, dark ink background).
 *
 * Pure presentational. The brand cluster, optional meta strip, and optional
 * user avatar are all driven by props. No router, no stores, no identity/auth.
 *
 * Layout:
 *   [brand-mark] [brand-name <em>] [sep] [meta: <b>label</b> · value]  …  [avatar]
 */

export interface HeaderBrand {
  mark: string;
  name: string;
  nameEm?: string;
}

export interface HeaderMetaItem {
  label: string;
  value: string;
}

export interface HeaderUser {
  name: string;
  role: string;
  initials: string;
}

export interface HeaderProps {
  brand: HeaderBrand;
  meta?: HeaderMetaItem[] | undefined;
  user?: HeaderUser | undefined;
}

export function Header({ brand, meta, user }: HeaderProps) {
  return (
    <header className="topbar" role="banner">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0, flexShrink: 0 }}>
        <span className="brand-mark">{brand.mark}</span>
        <span className="brand-name" style={{ whiteSpace: 'nowrap' }}>
          {brand.name}
          {brand.nameEm ? <em>{brand.nameEm}</em> : null}
        </span>
      </div>

      <span className="sep" style={{ flexShrink: 0 }} />

      {meta && meta.length > 0 && (
        <div className="tb-meta" style={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
          {meta.map((m) => (
            <span key={m.label}>
              <b>{m.label}</b> · {m.value}
            </span>
          ))}
        </div>
      )}

      <span style={{ marginLeft: 'auto' }} />

      {user && (
        <div className="tb-avatar">
          <span className="av-circle">{user.initials}</span>
          <div>
            <div className="nm">{user.name}</div>
            <div className="ro">{user.role}</div>
          </div>
        </div>
      )}
    </header>
  );
}
